import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { IData } from '../../helpers/interface';
interface IProps {
  moduleData: IData;
  machineData: any;
  toolsData: any;
  departmentData: any;
  isView: boolean;
  handelDeleteRows: any;
  gaugesData: any;
  fixturesData: any;
}

const TController = ({
  moduleData,
  machineData,
  toolsData,
  departmentData,
  isView,
  handelDeleteRows,
  gaugesData,
  fixturesData,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            departmentData,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
            handelDeleteRows,
            machineData,
            toolsData,
            gaugesData,
            fixturesData,
          }}
        />
        <TFoot
          {...{
            moduleData,
            isView,
          }}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
